import SortableContainer from './SortableContainer'
export default SortableContainer




// WEBPACK FOOTER //
// ./src/index.js